import React, { useEffect, useState } from 'react';

const SettingsForm = ({ settings, onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    company_name: '',
    company_address: '',
    company_postal_code: '',
    company_city: '',
    company_phone: '',
    company_email: '',
    company_website: '',
    siret: '',
    siren: '',
    tva_number: '',
    rcs: '',
    default_tax_rate: '20',
    quote_validity_days: '30',
    quote_footer: '',
    invoice_footer: '',
    bank_name: '',
    bank_iban: '',
    bank_bic: '',
    quote_counter: '1',
    invoice_counter: '1',
    quote_prefix: 'DEV',
    invoice_prefix: 'FACT',
    invoice_payment_terms: '30',
    business_hours: {
      monday: { open: '08:00', close: '18:00' },
      tuesday: { open: '08:00', close: '18:00' },
      wednesday: { open: '08:00', close: '18:00' },
      thursday: { open: '08:00', close: '18:00' },
      friday: { open: '08:00', close: '18:00' },
      saturday: { open: '08:00', close: '12:00' },
      sunday: { closed: true }
    }
  });

  const [errors, setErrors] = useState({});
  const [logoFile, setLogoFile] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(null);

  useEffect(() => {
    if (settings) {
      setFormData({
        company_name: settings.company_name || '',
        company_address: settings.company_address || '',
        company_postal_code: settings.company_postal_code || '',
        company_city: settings.company_city || '',
        company_phone: settings.company_phone || '',
        company_email: settings.company_email || '',
        company_website: settings.company_website || '',
        siret: settings.siret || '',
        siren: settings.siren || '',
        tva_number: settings.tva_number || '',
        rcs: settings.rcs || '',
        default_tax_rate: settings.default_tax_rate || '20',
        quote_validity_days: settings.quote_validity_days || '30',
        quote_footer: settings.quote_footer || '',
        invoice_footer: settings.invoice_footer || '',
        bank_name: settings.bank_name || '',
        bank_iban: settings.bank_iban || '',
        bank_bic: settings.bank_bic || '',
        quote_counter: settings.quote_counter || '1',
        invoice_counter: settings.invoice_counter || '1',
        quote_prefix: settings.quote_prefix || 'DEV',
        invoice_prefix: settings.invoice_prefix || 'FACT',
        invoice_payment_terms: settings.invoice_payment_terms || '30',
        business_hours: settings.business_hours || {
          monday: { open: '08:00', close: '18:00' },
          tuesday: { open: '08:00', close: '18:00' },
          wednesday: { open: '08:00', close: '18:00' },
          thursday: { open: '08:00', close: '18:00' },
          friday: { open: '08:00', close: '18:00' },
          saturday: { open: '08:00', close: '12:00' },
          sunday: { closed: true }
        }
      });

      if (settings.logo) setLogoPreview(settings.logo);
      if (settings.signature) setSignaturePreview(settings.signature);
    }
  }, [settings]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleBusinessHoursChange = (day, field, value) => {
    setFormData(prev => ({
      ...prev,
      business_hours: {
        ...prev.business_hours,
        [day]: field === 'closed' ? { closed: value } : {
          ...prev.business_hours[day],
          [field]: value
        }
      }
    }));
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      if (type === 'logo') { setLogoFile(file); setLogoPreview(URL.createObjectURL(file)); }
      if (type === 'signature') { setSignatureFile(file); setSignaturePreview(URL.createObjectURL(file)); }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.company_name.trim()) newErrors.company_name = "Le nom de l'entreprise est requis";
    if (formData.company_email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.company_email)) newErrors.company_email = "Format d'email invalide";
    if (formData.siret && !/^\d{14}$/.test(formData.siret.replace(/\s/g, ''))) newErrors.siret = 'Le SIRET doit contenir 14 chiffres';
    if (formData.siren && !/^\d{9}$/.test(formData.siren.replace(/\s/g, ''))) newErrors.siren = 'Le SIREN doit contenir 9 chiffres';
    if (formData.default_tax_rate && (isNaN(formData.default_tax_rate) || formData.default_tax_rate < 0 || formData.default_tax_rate > 100)) newErrors.default_tax_rate = 'Le taux de TVA doit être entre 0 et 100';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const submitData = {
      ...formData,
      default_tax_rate: parseFloat(formData.default_tax_rate),
      quote_validity_days: parseInt(formData.quote_validity_days),
      quote_counter: parseInt(formData.quote_counter),
      invoice_counter: parseInt(formData.invoice_counter),
      invoice_payment_terms: parseInt(formData.invoice_payment_terms),
      business_hours: JSON.stringify(formData.business_hours)
    };
    onSubmit && onSubmit(submitData, logoFile, signatureFile);
  };

  const days = [
    { key: 'monday', label: 'Lundi' },
    { key: 'tuesday', label: 'Mardi' },
    { key: 'wednesday', label: 'Mercredi' },
    { key: 'thursday', label: 'Jeudi' },
    { key: 'friday', label: 'Vendredi' },
    { key: 'saturday', label: 'Samedi' },
    { key: 'sunday', label: 'Dimanche' }
  ];

  return (
    <div className="settings-form-overlay">
      <div className="settings-form-container">
        <div className="settings-form-header">
          <h2>Paramètres de l'entreprise</h2>
          <button className="close-btn" onClick={onCancel}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="settings-form">
          {/* Informations entreprise */}
          <div className="form-section">
            <h3>Informations de l'entreprise</h3>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="company_name">Nom de l'entreprise *</label>
                <input id="company_name" name="company_name" value={formData.company_name} onChange={handleChange} placeholder="Christophe Dépanne" className={errors.company_name ? 'error' : ''} />
                {errors.company_name && <span className="error-text">{errors.company_name}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="company_phone">Téléphone</label>
                <input id="company_phone" name="company_phone" value={formData.company_phone} onChange={handleChange} placeholder="01.23.45.67.89" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="company_email">Email</label>
                <input type="email" id="company_email" name="company_email" value={formData.company_email} onChange={handleChange} placeholder="contact@christophedepanne.fr" className={errors.company_email ? 'error' : ''} />
                {errors.company_email && <span className="error-text">{errors.company_email}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="company_website">Site web</label>
                <input type="url" id="company_website" name="company_website" value={formData.company_website} onChange={handleChange} placeholder="https://christophedepanne.fr" />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="company_address">Adresse</label>
              <input id="company_address" name="company_address" value={formData.company_address} onChange={handleChange} placeholder="123 Avenue de la Mécanique" />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="company_postal_code">Code postal</label>
                <input id="company_postal_code" name="company_postal_code" value={formData.company_postal_code} onChange={handleChange} placeholder="75001" />
              </div>
              <div className="form-group">
                <label htmlFor="company_city">Ville</label>
                <input id="company_city" name="company_city" value={formData.company_city} onChange={handleChange} placeholder="Paris" />
              </div>
            </div>
          </div>

          {/* Informations légales */}
          <div className="form-section">
            <h3>Informations légales</h3>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="siret">SIRET</label>
                <input id="siret" name="siret" value={formData.siret} onChange={handleChange} placeholder="12345678901234" className={errors.siret ? 'error' : ''} />
                {errors.siret && <span className="error-text">{errors.siret}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="siren">SIREN</label>
                <input id="siren" name="siren" value={formData.siren} onChange={handleChange} placeholder="123456789" className={errors.siren ? 'error' : ''} />
                {errors.siren && <span className="error-text">{errors.siren}</span>}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="tva_number">Numéro TVA</label>
                <input id="tva_number" name="tva_number" value={formData.tva_number} onChange={handleChange} placeholder="FR12345678901" />
              </div>
              <div className="form-group">
                <label htmlFor="rcs">RCS</label>
                <input id="rcs" name="rcs" value={formData.rcs} onChange={handleChange} placeholder="Paris B 123 456 789" />
              </div>
            </div>
          </div>

          {/* Paramètres financiers */}
          <div className="form-section">
            <h3>Paramètres financiers</h3>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="default_tax_rate">Taux de TVA par défaut (%)</label>
                <input type="number" id="default_tax_rate" name="default_tax_rate" value={formData.default_tax_rate} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="decimal" min="0" max="100" step="0.01" className={errors.default_tax_rate ? 'error' : ''} />
                {errors.default_tax_rate && <span className="error-text">{errors.default_tax_rate}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="quote_validity_days">Validité des devis (jours)</label>
                <input type="number" id="quote_validity_days" name="quote_validity_days" value={formData.quote_validity_days} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="numeric" min="1" max="365" />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="invoice_payment_terms">Délai de paiement factures (jours)</label>
              <input type="number" id="invoice_payment_terms" name="invoice_payment_terms" value={formData.invoice_payment_terms} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="numeric" min="0" max="365" />
            </div>
          </div>

          {/* Numérotation */}
          <div className="form-section">
            <h3>Numérotation automatique</h3>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="quote_prefix">Préfixe devis</label>
                <input id="quote_prefix" name="quote_prefix" value={formData.quote_prefix} onChange={handleChange} placeholder="DEV" />
              </div>
              <div className="form-group">
                <label htmlFor="quote_counter">Compteur devis</label>
                <input type="number" id="quote_counter" name="quote_counter" value={formData.quote_counter} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="numeric" min="1" />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="invoice_prefix">Préfixe factures</label>
                <input id="invoice_prefix" name="invoice_prefix" value={formData.invoice_prefix} onChange={handleChange} placeholder="FACT" />
              </div>
              <div className="form-group">
                <label htmlFor="invoice_counter">Compteur factures</label>
                <input type="number" id="invoice_counter" name="invoice_counter" value={formData.invoice_counter} onChange={handleChange} onWheel={(e)=>e.currentTarget.blur()} inputMode="numeric" min="1" />
              </div>
            </div>
          </div>

          {/* Informations bancaires */}
          <div className="form-section">
            <h3>Informations bancaires</h3>
            <div className="form-group">
              <label htmlFor="bank_name">Nom de la banque</label>
              <input id="bank_name" name="bank_name" value={formData.bank_name} onChange={handleChange} placeholder="Crédit Mutuel" />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="bank_iban">IBAN</label>
                <input id="bank_iban" name="bank_iban" value={formData.bank_iban} onChange={handleChange} placeholder="FR76 1234 5678 ..." />
              </div>
              <div className="form-group">
                <label htmlFor="bank_bic">BIC</label>
                <input id="bank_bic" name="bank_bic" value={formData.bank_bic} onChange={handleChange} placeholder="CMCIFR2A" />
              </div>
            </div>
          </div>

          {/* Logo et signature */}
          <div className="form-section">
            <h3>Logo et signature</h3>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="logo">Logo de l'entreprise</label>
                <input type="file" id="logo" accept="image/*" onChange={(e) => handleFileChange(e, 'logo')} />
                {logoPreview && (
                  <div className="file-preview"><img src={logoPreview} alt="Logo" /></div>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="signature">Signature numérique</label>
                <input type="file" id="signature" accept="image/*" onChange={(e) => handleFileChange(e, 'signature')} />
                {signaturePreview && (
                  <div className="file-preview"><img src={signaturePreview} alt="Signature" /></div>
                )}
              </div>
            </div>
          </div>

          {/* Horaires d'ouverture */}
          <div className="form-section">
            <h3>Horaires d'ouverture</h3>
            <div className="business-hours">
              {days.map(day => (
                <div key={day.key} className="day-hours">
                  <div className="day-label">{day.label}</div>
                  <div className="hours-inputs">
                    <label className="checkbox-label">
                      <input type="checkbox" checked={formData.business_hours[day.key]?.closed || false} onChange={(e) => handleBusinessHoursChange(day.key, 'closed', e.target.checked)} />
                      <span>Fermé</span>
                    </label>
                    {!formData.business_hours[day.key]?.closed && (
                      <>
                        <input type="time" value={formData.business_hours[day.key]?.open || '08:00'} onChange={(e) => handleBusinessHoursChange(day.key, 'open', e.target.value)} />
                        <span>à</span>
                        <input type="time" value={formData.business_hours[day.key]?.close || '18:00'} onChange={(e) => handleBusinessHoursChange(day.key, 'close', e.target.value)} />
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Pieds de page */}
          <div className="form-section">
            <h3>Pieds de page des documents</h3>
            <div className="form-group">
              <label htmlFor="quote_footer">Pied de page des devis</label>
              <textarea id="quote_footer" name="quote_footer" value={formData.quote_footer} onChange={handleChange} rows="3" placeholder="Devis valable 30 jours..." />
            </div>
            <div className="form-group">
              <label htmlFor="invoice_footer">Pied de page des factures</label>
              <textarea id="invoice_footer" name="invoice_footer" value={formData.invoice_footer} onChange={handleChange} rows="3" placeholder="Paiement à 30 jours..." />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn-cancel">Annuler</button>
            <button type="submit" disabled={loading} className="btn-submit">{loading ? 'Enregistrement...' : 'Enregistrer les paramètres'}</button>
          </div>
        </form>

        <style>{`
          .settings-form-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:1000; padding:20px; }
          .settings-form-container { background: var(--admin-panel); color: var(--admin-text); border:1px solid var(--admin-border); border-radius:12px; width:100%; max-width:900px; max-height:90vh; overflow-y:auto; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.3); }
          .settings-form-header { display:flex; justify-content:space-between; align-items:center; padding:24px 24px 0 24px; border-bottom:1px solid var(--admin-border); margin-bottom:24px; position: sticky; top:0; background: var(--admin-panel); z-index:10; }
          .settings-form-header h2 { margin:0; font-size:1.5rem; font-weight:600; }
          .close-btn { background:none; border:1px solid var(--admin-border); color: var(--admin-muted); cursor:pointer; padding:8px; border-radius:6px; }
          .close-btn:hover { background: var(--admin-panel-2); color: var(--admin-text); }
          .settings-form { padding:0 24px 24px 24px; }
          .form-section { margin-bottom:32px; padding-bottom:24px; border-bottom:1px solid var(--admin-border); }
          .form-section:last-of-type { border-bottom:none; }
          .form-section h3 { margin:0 0 20px 0; font-size:1.2rem; font-weight:600; border-left:4px solid var(--admin-accent); padding-left:12px; }
          .form-row { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:16px; }
          @media (max-width: 640px) { .form-row { grid-template-columns:1fr; } }
          .form-group { position:relative; margin-bottom:16px; }
          .form-group label { display:block; margin-bottom:6px; font-weight:500; color: var(--admin-muted); font-size:.9rem; }
          .form-group input, .form-group select, .form-group textarea { width:100%; padding:12px 16px; border:1px solid var(--admin-border); border-radius:8px; font-size:.9rem; background: var(--admin-panel-2); color: var(--admin-text); }
          .form-group input:focus, .form-group select:focus, .form-group textarea:focus { outline:none; border-color: var(--admin-accent); box-shadow: 0 0 0 3px rgba(79,70,229,0.15); }
          .form-group input.error, .form-group select.error, .form-group textarea.error { border-color:#dc2626; }
          .form-group textarea { resize:vertical; min-height:80px; }
          .error-text { color:#f87171; font-size:.8rem; margin-top:4px; display:block; }
          .file-preview { margin-top:8px; }
          .file-preview img { max-width:200px; max-height:100px; border-radius:6px; border:1px solid var(--admin-border); }
          .business-hours { display:flex; flex-direction:column; gap:12px; }
          .day-hours { display:flex; align-items:center; gap:16px; padding:12px; background: var(--admin-panel-2); border:1px solid var(--admin-border); border-radius:8px; }
          .day-label { min-width:80px; font-weight:500; }
          .hours-inputs { display:flex; align-items:center; gap:8px; flex:1; }
          .checkbox-label { display:flex; align-items:center; gap:6px; cursor:pointer; font-size:.9rem; }
          .checkbox-label input[type="checkbox"] { width:auto; margin:0; }
          .hours-inputs input[type="time"] { width:auto; padding:6px 8px; margin:0; border:1px solid var(--admin-border); background: var(--admin-panel); color: var(--admin-text); border-radius:6px; }
          .form-actions { display:flex; gap:12px; justify-content:flex-end; margin-top:32px; padding:24px; border-top:1px solid var(--admin-border); position: sticky; bottom:0; background: var(--admin-panel); }
          .btn-cancel, .btn-submit { padding:12px 24px; border-radius:8px; font-weight:500; cursor:pointer; border:1px solid var(--admin-border); font-size:.9rem; }
          .btn-cancel { background: var(--admin-panel-2); color: var(--admin-text); }
          .btn-cancel:hover { background: rgba(255,255,255,0.06); }
          .btn-submit { background: var(--admin-accent); color:white; border-color: transparent; }
          .btn-submit:hover:not(:disabled) { filter: brightness(1.05); }
          .btn-submit:disabled { opacity:.6; cursor:not-allowed; }
        `}</style>
      </div>
    </div>
  );
};

export default SettingsForm;
